import { Map } from "immutable";

import { ACTIONS, FACILITY_TYPE } from "features/planner/planner.constants";
import { FacilityMapper, FieldMapper } from "features/planner/planner.mappers";

const initialState = Map({
  facilities: Map({
    [FACILITY_TYPE.MOBILE]: Map(),
    [FACILITY_TYPE.FIXED]: Map(),
  }),
  fields: Map(),
});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_STATIONARY_AND_MOBILE_FACILITIES: {
      if (error) return state;

      const [stationaryFacilities, mobileFacilities] = payload;

      return state
        .setIn(
          ["facilities", FACILITY_TYPE.FIXED.toString()],
          Map(
            stationaryFacilities.map(facility => [
              facility.facilityId.toString(),
              FacilityMapper.from(facility),
            ]),
          ),
        )
        .setIn(
          ["facilities", FACILITY_TYPE.MOBILE.toString()],
          Map(
            mobileFacilities.map(facility => [
              facility.mobileFacilityId.toString(),
              FacilityMapper.from(facility),
            ]),
          ),
        );
    }

    case ACTIONS.GET_FIELDS: {
      if (error) return state;

      return state.set(
        "fields",
        Map(
          payload.map(field => [
            field.fieldId.toString(),
            FieldMapper.from(field),
          ]),
        ),
      );
    }

    case ACTIONS.UPDATE_FIELD:
    case ACTIONS.CREATE_FIELD: {
      if (error) return state;

      return state.setIn(
        ["fields", payload.fieldId.toString()],
        FieldMapper.from(payload),
      );
    }
    case ACTIONS.DELETE_FIELD: {
      if (error) return state;

      return state.deleteIn(["fields", action.fieldId.toString()]);
    }

    case ACTIONS.UPDATE_FIXED_FACILITY:
    case ACTIONS.CREATE_FIXED_FACILITY: {
      if (error) return state;

      return state.setIn(
        [
          "facilities",
          FACILITY_TYPE.FIXED.toString(),
          payload.facilityId.toString(),
        ],
        FacilityMapper.from(payload),
      );
    }
    case ACTIONS.DELETE_FIXED_FACILITY: {
      if (error) return state;

      return state.deleteIn([
        "facilities",
        FACILITY_TYPE.FIXED.toString(),
        action.facilityId.toString(),
      ]);
    }

    case ACTIONS.UPDATE_MOBILE_FACILITY:
    case ACTIONS.CREATE_MOBILE_FACILITY: {
      if (error) return state;

      return state.setIn(
        [
          "facilities",
          FACILITY_TYPE.MOBILE.toString(),
          payload.mobileFacilityId.toString(),
        ],
        FacilityMapper.from(payload),
      );
    }
    case ACTIONS.DELETE_MOBILE_FACILITY: {
      if (error) return state;

      return state.deleteIn([
        "facilities",
        FACILITY_TYPE.MOBILE.toString(),
        action.mobileFacilityId.toString(),
      ]);
    }

    default:
      return state;
  }
};
